console.log()
export default {
  /**
     * @description api请求基础路径
     */
  baseUrl: {
    // pro: 'http://localhost:7745',
    pro: window.GlobalVariable.BaseUrl,
    // pro: 'http://47.93.203.158:8070/admin',
  },
  /**
     * @description 默认打开的首页的路由name值，默认为home
     */
  homeName: "home",
  // imgServer: "http://47.93.203.158:8070/img/newsimage/"
  // imgServer: "http://192.168.1.124:8099/img/newsimage/",
  imgServer: window.GlobalVariable.imgServer,
  StudentEnCode: "curriculum",
  companyUserList: window.GlobalVariable.companyUserList,
  loginservice: window.GlobalVariable.loginservice,
}



// WEBPACK FOOTER //
// ./src/config/index.js